  document.addEventListener('DOMContentLoaded', function() {
    const track = document.querySelector('.testimonials-track');
    
    if (!track) return;
    
    let currentIndex = 0;
    const totalCards = track.children.length;
    
    function getVisibleCards() {
      return window.innerWidth <= 768 ? 1 : 3;
    }
    
    let maxIndex = Math.max(0, totalCards - getVisibleCards());
    
    function updateSlider() {
      const cardWidth = window.innerWidth <= 768 ? track.offsetWidth : 248;
      const gap = window.innerWidth <= 768 ? 0 : 8;
      const translateX = -currentIndex * (cardWidth + gap);
      track.style.transform = `translateX(${translateX}px)`;
      
      const prevButtons = document.querySelectorAll('.slider-nav.prev');
      const nextButtons = document.querySelectorAll('.slider-nav.next');
      
      prevButtons.forEach(btn => btn.disabled = currentIndex === 0);
      nextButtons.forEach(btn => btn.disabled = currentIndex >= maxIndex);
    }
    
    function goToPrevious() {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    }
    
    function goToNext() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSlider();
      }
    }
    
    document.addEventListener('click', function(e) {
      if (e.target.closest('.slider-nav.prev')) {
        goToPrevious();
      } else if (e.target.closest('.slider-nav.next')) {
        goToNext();
      }
    });
    
    window.addEventListener('resize', function() {
      maxIndex = Math.max(0, totalCards - getVisibleCards());

      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }

      updateSlider();
    });
    
    updateSlider();
  });

    // Expand/Collapse for testimonials
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.expand-btn');
    if (!btn) return;

    const targetId = btn.getAttribute('data-target');
    const textBlock = document.getElementById(targetId);
    if (!textBlock) return;

    textBlock.classList.toggle('expanded');

    const expandText = btn.querySelector('.expand-text');
    const collapseText = btn.querySelector('.collapse-text');

    if (textBlock.classList.contains('expanded')) {
      expandText.style.display = 'none';
      collapseText.style.display = 'inline';
    } else {
      expandText.style.display = 'inline';
      collapseText.style.display = 'none';
    }
  });

 


